import useAuthStore from '@/features/auth/stores/authStore';
import React from 'react';
import { Navigate, Outlet } from 'react-router';

export const LoginLayout = () => {
  const isAuthorized = useAuthStore((x) => x.isAuthorized);
  const authorized = isAuthorized();

  return authorized ? <Navigate to="/requests" /> : <Outlet />;
};
